import listActions from 'src/modules/keyword/list/keywordListActions';
import KeywordService from 'src/modules/keyword/keywordService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'KEYWORD_DESTROY';

const keywordDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: keywordDestroyActions.DESTROY_STARTED,
      });

      await KeywordService.destroyAll([id]);

      dispatch({
        type: keywordDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.keyword.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/keyword');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: keywordDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: keywordDestroyActions.DESTROY_ALL_STARTED,
      });

      await KeywordService.destroyAll(ids);

      dispatch({
        type: keywordDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doChangeSelected([]));
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.keyword.destroyAll.success'),
      );

      getHistory().push('/keyword');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: keywordDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default keywordDestroyActions;
